"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _breakpointObserver = require("@decisiv/breakpoint-observer");

var _designTokens = require("@decisiv/design-tokens");

var _Times = _interopRequireDefault(require("@decisiv/iconix/lib/components/Times"));

var _ConfigProvider = require("../../providers/ConfigProvider");

var _canUseDOM = _interopRequireDefault(require("../../utils/canUseDOM"));

var _commonUIColors = require("../../utils/commonUIColors");

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

var _Button = _interopRequireDefault(require("../Button"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _Typography = require("../Typography");

var _components = require("./components");

var _constants = require("./constants");

var _proptypeValidators = require("./proptypeValidators");

var _schema = _interopRequireDefault(require("./schema"));

var _utils = require("./utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var actionProps = [{}, {
  kind: 'secondary'
}];

function Modal(_ref) {
  var _ref2, _ref3, _ref4, _ref5, _ref6;

  var actions = _ref.actions,
      children = _ref.children,
      closeHint = _ref.closeHint,
      colorProp = _ref.color,
      icon = _ref.icon,
      id = _ref.id,
      intent = _ref.intent,
      onClose = _ref.onClose,
      title = _ref.title,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 100 : _ref$zIndex;

  var breakpoints = _defineProperty({}, _breakpointObserver.sizes.LG, 650);

  var _useBreakpointObserve = (0, _breakpointObserver.useBreakpointObserver)(breakpoints),
      _useBreakpointObserve2 = _slicedToArray(_useBreakpointObserve, 2),
      observedElementRef = _useBreakpointObserve2[0],
      breakpoint = _useBreakpointObserve2[1].breakpoint;

  var translate = (0, _useTranslations.default)();
  var IconComponent = (0, _react.useMemo)(function () {
    if (intent || _designTokens.color && icon) {
      var intentValues = intent && _constants.intents[intent] || {};
      var finalColor = colorProp ? _commonUIColors.commonUIColors[colorProp] || (0, _get.default)(intentValues, 'color') : (0, _get.default)(intentValues, 'color');
      var Icon = icon || (0, _get.default)(intentValues, 'icon');
      return finalColor && Icon ? _react.default.createElement(Icon, {
        color: (0, _toColorString.default)(finalColor),
        size: "large"
      }) : null;
    }

    return null;
  }, [colorProp, icon, intent]);

  var _useElement = (0, _utils.useElement)(),
      _useElement2 = _slicedToArray(_useElement, 2),
      container = _useElement2[0],
      containerRef = _useElement2[1];

  (0, _utils.useKeepFocusWithin)(container);
  var uuid = (0, _useUniqueId.default)(id, 'modal-');
  var modalHeaderId = "modal-header-".concat(uuid);
  var modalContentId = "modal-content-".concat(uuid);
  var modalFooterId = "modal-footer-".concat(uuid); // Any click within the overlay should stay within the overlay. This click event should close
  // the modal, but not bubble up to any parent elements.

  var handleOverlayClick = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    onClose && onClose(event);
  }, [onClose]); // Any click within the body should stay within the body. This prevents the click event from
  // bubbling up and firing the onClose handler via the Overlay's onClick.

  var handleBodyClick = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
  }, []);
  return _react.default.createElement(_components.Overlay, {
    onClick: handleOverlayClick,
    ref: observedElementRef,
    zIndex: zIndex
  }, _react.default.createElement(_components.Body, {
    "aria-describedby": modalContentId,
    "aria-labelledby": modalHeaderId,
    "aria-modal": "true",
    size: breakpoint,
    id: uuid,
    onClick: handleBodyClick,
    ref: containerRef,
    role: "dialog"
  }, _react.default.createElement(_components.ScrollYBox, {
    size: breakpoint
  }, _react.default.createElement(_components.Header, {
    id: modalHeaderId,
    paddingTop: (_ref2 = {}, _defineProperty(_ref2, _breakpointObserver.sizes.LG, 3), _defineProperty(_ref2, _breakpointObserver.sizes.XS, 2), _ref2),
    paddingX: (_ref3 = {}, _defineProperty(_ref3, _breakpointObserver.sizes.LG, 3), _defineProperty(_ref3, _breakpointObserver.sizes.XS, 2), _ref3),
    size: breakpoint
  }, onClose && _react.default.createElement(_components.CloseButtonContainer, null, _react.default.createElement(_Tooltip.default, {
    placement: "top",
    target: // eslint-disable-next-line
    _react.default.createElement(_Button.default, {
      "aria-label": translate(closeHint, 'modal.closeHint'),
      icon: _Times.default,
      onClick: onClose,
      variant: "ghost"
    }),
    zIndex: zIndex + 10
  }, translate(closeHint, 'modal.closeHint'))), IconComponent && _react.default.createElement(_Flex.default, {
    marginRight: 1
  }, IconComponent), _react.default.createElement(_Typography.H2, null, title)), _react.default.createElement(_components.Content, {
    hasIcon: !!IconComponent,
    id: modalContentId,
    paddingBottom: (_ref4 = {}, _defineProperty(_ref4, _breakpointObserver.sizes.LG, 3), _defineProperty(_ref4, _breakpointObserver.sizes.XS, 2), _ref4),
    paddingX: (_ref5 = {}, _defineProperty(_ref5, _breakpointObserver.sizes.LG, 3), _defineProperty(_ref5, _breakpointObserver.sizes.XS, 2), _ref5),
    size: breakpoint
  }, children)), actions && _react.default.createElement(_components.Footer, {
    hasIcon: !!IconComponent,
    id: modalFooterId,
    paddingX: (_ref6 = {}, _defineProperty(_ref6, _breakpointObserver.sizes.LG, 3), _defineProperty(_ref6, _breakpointObserver.sizes.XS, 2), _ref6),
    paddingY: 2,
    size: breakpoint
  }, actions.map(function (action, index) {
    return _react.default.createElement(_Flex.default, {
      key: action.text,
      marginRight: 0.5
    }, _react.default.createElement(_Button.default, _extends({}, (0, _omit.default)(action, ['kind', 'size', 'variant']), actionProps[index])));
  }))));
}

function Manager(_ref7) {
  var onClose = _ref7.onClose,
      visible = _ref7.visible,
      children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ["onClose", "visible", "children"]);

  (0, _utils.useReturnFocus)(!visible);

  var _useConfig = (0, _ConfigProvider.useConfig)(),
      createPortal = _useConfig.createPortal;

  var onKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'Escape') {
      onClose && onClose(event);
    }
  }, [onClose]); // Allow closing the modal by pressing the Escape key

  (0, _react.useEffect)(function () {
    if (visible && _canUseDOM.default) {
      document.addEventListener('keydown', onKeyDown);
      return function () {
        document.removeEventListener('keydown', onKeyDown);
      };
    } // eslint has issues with no return statement here...


    return undefined;
  }, [visible, onKeyDown]);

  if (visible) {
    return createPortal(_react.default.createElement(Modal, _extends({
      onClose: onClose
    }, rest), children));
  }

  return null;
} // @ts-ignore


Manager.propTypes = _objectSpread({}, _schema.default.propTypes, {
  actions: _proptypeValidators.actionsValidator,
  icon: _propTypes.default.elementType
});
Manager.displayName = 'Modal';
var _default = Manager;
exports.default = _default;